<template>
  <div class="boxInfo">
    <el-tabs
      type="border-card" style="height: 100%;" :value="'first'"
      @tab-click="handleTabClick"
    >
      <!--'新增分区'\'分区详情'-->
      <el-tab-pane :label="typeIndex === 1 ? $t('basicData.AddPartition') : $t('basicData.PartitionDetails')" name="first">
        <div class="addFormBox">
          <el-form
            ref="queryForm"
            class="queryFormClass"
            :model="formData"
            :rules="rules"
            size="small"
            :label-width="$i18n.locale==='zh'?'120px':''"
            :label-position="$i18n.locale!=='zh'?'top':'right'"
          >
            <el-row>
              <el-col :span="20">
                <!--分区方案名称-->
                <el-form-item :label="$t('basicData.PartitionSchemeName')" prop="name">
                  <el-input
                    v-model.trim="formData.name"
                    :placeholder="$t('orderDetails.pleaseInput')"
                    clearable
                    maxlength="40"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <!--备注内容-->
                <el-form-item :label="$t('basicData.RemarkContent')">
                  <el-input
                    v-model="formData.remark"
                    :placeholder="$t('orderDetails.pleaseInput')"
                    type="textarea"
                    :rows="3"
                    maxlength="200"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <!--业务类型-->
                <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">
                  <el-select v-model="formData.businessType" :placeholder="$t('GlobalSetObj.pleaseChoose')">
                    <el-option
                      v-for="item in P_BUSINESS_TYPE"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <!--操作按钮-->
          <div class="feet-r mb10">
            <template v-if="typeIndex !== 3">
              <!--新增分区 "-->
              <el-button
                v-permit:remove="'btn:finance:basicData:payable:partition-add'"
                size="small"
                type="primary"
                @click="handleAdd"
              >{{ $t('basicData.AddPartition') }}
              </el-button>

              <el-popover
                placement="bottom-start"
                trigger="hover"
              >
                <import-download
                  :table-data="formData" :all-state="allState"
                  :all-city="allCity" @importPartition="importPartition"
                />
                <!--导入/下载 -->
                <template #reference>
                  <el-button size="small" plain>
                    {{ $t('basicData.ImportDownload') }}
                  </el-button>
                </template>
              </el-popover>
            </template>
            <!-- 搜索-->
            <el-input
              v-model="searchCode"
              :placeholder="$t('basicData.zipCode')"
              size="small"
              clearable
              style="width: 350px"
              @clear="clearHighlight"
            >
              <template #prepend>{{ $t('basicData.zipCode') }}</template>
              <template #append>
                <el-button icon="el-icon-search" @click="handleSearch" />
              </template>
            </el-input>
            <el-button-group>
              <el-button
                :disabled="!hasSearchResults || currentHighlightIndex <= 0"
                size="small" icon="el-icon-arrow-left"
                @click="highlightPrev"
              >{{ $t('mdfeTranslate.Previous') }}</el-button>
              <el-button
                :disabled="!hasSearchResults" size="small"
                type="primary"
              >
                {{ currentHighlightIndex + 1 }}/{{ searchResults.length }}
              </el-button>
              <el-button
                :disabled="!hasSearchResults || currentHighlightIndex >= searchResults.length - 1"
                size="small" @click="highlightNext"
              >{{ $t('mdfeTranslate.Next') }}
                <i class="el-icon-arrow-right el-icon--right" /></el-button>
            </el-button-group>
          </div>
          <!--分区明细-->
          <el-form
            ref="tableForm"
            :model="formData"
            size="small"
            class="error-form"
            label-width="0px"
          >
            <virtual-scroll
              ref="virtualScroll"
              :key="key"
              :data="formData.partitionAffiliateList"
              :item-size="76"
              key-prop="key"
              @change="(virtualList) => list = virtualList"
            >
              <el-table
                ref="tableRef"
                :data="list"
                border
                row-key="key"
                :height="500"
                :row-class-name="getRowClassName"
                :highlight-current-row="false"
              >
                <virtual-column width="80" type="index" />
                <el-table-column :label="$t('basicData.PartitionName')" width="200">
                  <template #header>
                    <div>
                      <!--分区名称-->
                      <span style="color: red;">*</span>
                      <span>{{ $t('basicData.PartitionName') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :prop="'partitionAffiliateList.' + scope.$index + '.partitionIdentifier'"
                      :rules="{required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change']}"
                    >
                      <el-input
                        v-model="scope.row.partitionIdentifier"
                        maxlength="50"
                        show-word-limit
                        :placeholder="$t('basicData.PartitionName')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('GlobalSetObj.Estado')" width="240">
                  <template #header>
                    <div>
                      <!--州-->
                      <span style="color: red;">*</span>
                      <span>{{ $t('GlobalSetObj.Estado') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :prop="'partitionAffiliateList.' + scope.$index + '.state'"
                      :rules="{ required: (scope.row.postalCode === '' && scope.row.city.length === 0), message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                    >
                      <el-select
                        v-model="scope.row.state"
                        multiple
                        clearable
                        filterable
                        collapse-tags
                        :placeholder="$t('GlobalSetObj.pleaseChoose')"
                        @change="changeState(scope)"
                      >
                        <el-option
                          v-for="item in scope.row.allState"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                          <span style="float: left">{{ item.label }}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('orderCenterCont.city')" width="180">
                  <template #header>
                    <div>
                      <!--城市-->
                      <span style="color: red;">*</span>
                      <span>{{ $t('orderCenterCont.city') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <div :key="cityKey">
                      <el-form-item
                        :prop="'partitionAffiliateList.' + scope.$index + '.city'"
                        :rules="{ required: (scope.row.postalCode === '' && scope.row.state.length === 0), message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                      >
                        <el-select
                          v-model="scope.row.city"
                          multiple
                          clearable
                          filterable
                          collapse-tags
                          :placeholder="$t('GlobalSetObj.pleaseChoose')"
                        >
                          <el-option
                            v-for="item in scope.row.allCity"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('basicData.zipCode')">
                  <template #header>
                    <div>
                      <!--邮编-->
                      <span style="color: red;">*</span>
                      <span>{{ $t('basicData.zipCode') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :prop="'partitionAffiliateList.' + scope.$index + '.postalCode'"
                      :rules="{
                        required: (scope.row.city.length === 0 && scope.row.state.length === 0),
                        validator: postalCodeCheck,
                        trigger: ['blur', 'change'] }"
                    >
                      <el-input
                        v-model="scope.row.postalCode"
                        type="textarea"
                        :rows="2"
                        :placeholder="$t('basicData.ZipCodeExample')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!--操作-->
                <el-table-column :label="$t('basicData.operate')" width="100">
                  <template v-slot="scope">
                    <!--确定删除吗？-->
                    <el-popconfirm
                      :title="$t('basicData.AreYouSureYouWantToDelete')"
                      @confirm="handleDel(scope)"
                    >
                      <!--删除-->
                      <template #reference>
                        <el-button type="danger" size="mini">{{ $t('basicData.Delete') }}</el-button>
                      </template>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </virtual-scroll>
          </el-form>
        </div>

        <div class="addFooter">
          <!--取消-->
          <el-button size="small" @click="() => handleUpdatePage(false)">{{ $t('basicData.Cancel') }}</el-button>
          <!--保存-->
          <el-button
            v-permit:remove="'btn:finance:basicData:payable:partition-edit'" size="small" type="primary"
            @click="submitForm"
          >{{ $t('basicData.Save') }}</el-button>
        </div>
      </el-tab-pane>

      <!--操作日志-->
      <el-tab-pane v-if="typeIndex === 2" :label="$t('basicData.OperationalLogs')" name="second">
        <operation-log v-if="isSecondActive" :edit-data="editData" />
      </el-tab-pane>
    </el-tabs>

    <!--保存提示-->
    <el-dialog
      :title="$t('basicData.tips')"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="30%"
    >
      <div v-for="(item, ind) in errData" :key="ind" style="color: red;margin-bottom: 10px;">{{ item }}</div>
      <span slot="footer" class="dialog-footer">
        <!--确 定-->
        <el-button type="primary" @click="dialogVisible = false">{{ $t('basicData.determine') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiAffiliateAdd, apiAffiliateDelete, apiAffiliateEdit, apiGetAffiliateById } from '@/api/finance/partition';
import { Loading } from 'element-ui';
import { apiAreaPage } from '@/api/finance/basicData';
import { cloneDeep } from 'lodash-es';
import { P_BUSINESS_TYPE } from '@/views/finance/enums.js';
import VirtualScroll, { VirtualColumn } from 'el-table-virtual-scroll';
import { postalCodeFormat, rowComparison } from '@/views/finance/basicData/partition/cmp/utils';

const options = {
  lock: true,
  spinner: 'el-icon-loading',
  text: 'loading...',
  background: 'rgba(250, 250, 250, 0.6)' // 加载动画的背景
};
export default {
  components: {
    VirtualScroll,
    VirtualColumn,
    'import-download': () => import('./ImportDownload'),
    'operation-log': () => import('./operationLog')
  },
  props: {
    // 类型标识 1新增 2编辑 3查看
    typeIndex: {
      type: Number,
      default: 1
    },
    // 编辑数据
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 所有州
    allState: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 所有城市
    allCity: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    // 邮编校验
    const postalCodeCheck = (rule, value, callback) => {
      // 必填项
      if (!rule.required) {
        return callback();
      }
      // 格式校验
      {
        const [isBool, text] = postalCodeFormat(value.trim());
        if (!isBool) {
          return callback(new Error(text));
        }
      }

      // 同行比较重叠的情况
      {
        const [isBool, text] = rowComparison(value);
        console.log(isBool, text, '区间校验');
        if (!isBool) {
          return callback(new Error(text));
        }
      }

      return callback();
    };
    return {
      rules: {
        name: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] },
          // '长度在 2 到 40 个字符'
          {
            min: 2,
            max: 40,
            message: this.$i18n.t('basicData.TheLengthBetween2And40Characters'),
            trigger: ['blur', 'change']
          }
        ],
        businessType: { required: true, message: this.$i18n.t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
      },
      postalCodeCheck,
      P_BUSINESS_TYPE,
      list: [],
      key: new Date().getTime(),
      errData: [],
      dialogVisible: false,
      formData: {
        name: '',
        remark: '',
        businessType: '',
        partitionAffiliateList: []
      },
      cityKey: new Date().getTime(),
      isSecondActive: false,
      // 响应式数据
      visibleData: [],
      searchCode: '',
      searchResults: [],
      currentHighlightIndex: -1
    };
  },
  computed: {
    hasSearchResults() {
      return this.searchResults.length > 0;
    }
  },
  watch: {
    searchCode(newVal) {
      if (!newVal) {
        this.clearHighlight();
      } else {
        this.handleSearch(); // 自动搜索定位
      }
    }
  },
  created() {
    if (this.editData.id) {
      // 报价页面查看分区使用partitionId， 分区页面使用id
      const ids = this.typeIndex === 3 ? this.editData.partitionId : this.editData.id;
      this.asyncGetAffiliateById(ids);
    }
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === 'second' && !this.isSecondActive) {
        this.isSecondActive = true; // 触发 ConfigManagement 组件的加载和初始化请求
      }
    },
    // 州省选项切换获取城市
    changeState(scope) {
      this.formData.partitionAffiliateList[scope.$index].allCity = [];
      this.formData.partitionAffiliateList[scope.$index].city = '';
      const func = function(data) {
        return data.map(item => ({
          label: item.twoCode,
          value: item.id,
          name: item.name
        }));
      };
      if (scope.row.state.length > 0) {
        const param = {
          pageNumber: 1,
          pageSize: 99999,
          params: {
            level: 2,
            parentIdList: scope.row.state
          }
        };
        apiAreaPage(param, false).then(res => {
          if (res.code === 200) {
            this.formData.partitionAffiliateList[scope.$index].allCity = func(res.data.records);
          }
        });
      } else {
        this.formData.partitionAffiliateList[scope.$index].allCity = this.allCity;
      }
      this.cityKey = new Date().getTime();
    },
    // 增加分区
    handleAdd() {
      this.formData.partitionAffiliateList = this.formData.partitionAffiliateList || [];
      const obj = {
        id: '',
        partitionIdentifier: '',
        postalCode: '',
        allState: this.allState,
        allCity: this.allCity,
        state: '',
        city: '',
        key: `item-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
      };
      this.formData.partitionAffiliateList.push(obj);
    },
    // 导入分区
    importPartition(arr) {
      let isId = false;
      const arrData = arr.map((item, index) => {
        if (item.id) {
          isId = true;
        }
        return {
          postalCode: item.zipcode,
          state: (item.state && item.state.length > 0) ? item.state : [],
          allState: this.allState,
          allCity: item.allCity,
          city: (item.city && item.city.length > 0) ? item.city : [],
          partitionIdentifier: item.name,
          id: item.id ? item.id : '',
          key: this.generateUniqueKey(index)
        };
      });
      if (isId) {
        this.formData.partitionAffiliateList = [...arrData];
      } else {
        this.formData.partitionAffiliateList = [...this.formData.partitionAffiliateList, ...arrData];
      }
      this.key = new Date().getTime();
    },
    // 删除分区
    handleDel(scope) {
      if (scope.row.id) {
        apiAffiliateDelete(scope.row.id).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
          }
        });
      }
      this.formData.partitionAffiliateList.splice(scope.$index, 1);
    },
    // 取消
    handleUpdatePage(type) {
      this.$emit('updatePage', type);
    },
    // 邮编校验
    verifyZipCode(arr) {
      // arr=分区列表
      const errObj = {
        // 格式错误
        errArr: [],
        // 交集错误
        repeat: []
      };
      // const reg = /^[A-Z0-9 \-]+$/g;
      const reg = /[A-Z \-]*[0-9]+/g; // 至少存在一个数字
      // 校验格式
      arr.forEach((item, ind) => {
        if (!item.state && !item.city && !item.postalCode) {
          // 州、城市、邮编，至少一项必填
          errObj.errArr.push((ind + 1) + '：' + this.$t('basicData.StateCityZipCodeLeastOneRequired'));
        }

        // item = 每行对象, ind下标
        console.log('item', item.postalCode);
        let zipcodeStr = '';
        if (item.postalCode) {
          // 清除字符串两端空白
          zipcodeStr = item.postalCode.trim();
        }

        // 替换 所有中文逗号为英文逗号
        zipcodeStr = zipcodeStr.replace(/，/ig, ',');

        // 没有填写,格式错误
        // if (zipcodeStr.length === 0) {
        //   if (!errObj.errArr.includes(ind + 1)) {
        //     // 这一整行邮编错误
        //     errObj.errArr.push(ind + 1);
        //   }
        // }
        // 获取每个分区的邮编,逗号分隔成数组
        const zipcodeArr = [];
        zipcodeStr.split(',').map(item => {
          if (item.trim()) {
            zipcodeArr.push(item.trim());
          }
        });
        console.log('zipcodeArr', zipcodeArr);
        // 不能出现 "41900,,,"
        if (zipcodeArr.includes('')) {
          if (zipcodeStr) {
            errObj.errArr.push(ind + 1 + '：' + this.$t('basicData.areMalformed'));
          }
          // if (!errObj.errArr.includes(ind + 1)) {
          //   errObj.errArr.push(ind + 1 + '：' + this.$t('basicData.areMalformed'));
          // }
        }

        const isBool = zipcodeArr.every(item => {
          let dataList = [];
          if (item) {
            dataList = item.split('~');
          }
          const list = dataList.map(item => {
            return item.trim();
          });

          if (list.length === 1) {
            reg.lastIndex = 0;
            return reg.test(list[0]);
          }

          // 不能出现 100~1000~10000
          if (list.length >= 3) {
            return false;
          }

          // 不能出现 "~100" "~" "100~"
          if (list.includes('')) {
            return false;
          }

          // 不能出现 10~9 10~10，前提是都为纯数字
          const num1 = Number(list[0]);
          const num2 = Number(list[1]);
          if ((num1 >= 0) && (num2 >= 0) && (num1 >= num2)) {
            return false;
          }

          return list.every(key => {
            reg.lastIndex = 0;
            return reg.test(key);
          });
        });

        if (!isBool) {
          // 邮箱不合格
          if (!errObj.errArr.includes(ind + 1)) {
            errObj.errArr.push(ind + 1 + '：' + this.$t('basicData.areMalformed'));
          }
        }
      });
      if (errObj.errArr.length > 0) {
        return errObj;
      }
      // 校验邮编
      for (let i = 0; i < arr.length; i++) {
        const itemA = arr[i];
        let zipcodeStrA = '';
        if (itemA.postalCode) {
          // 清除字符串两端空白
          zipcodeStrA = itemA.postalCode.trim();
        }
        // 替换 所有中文逗号为英文逗号
        zipcodeStrA = zipcodeStrA.replace(/，/ig, ',');
        // 获取每个分区的邮编,逗号分隔成数组,并删除空白
        const zipcodeArrA = zipcodeStrA.split(',').map(item => {
          return item.trim();
        });
        // 需要脚本本身是否存在交集
        for (let j = 0; j < zipcodeArrA.length; j++) {
          const postalCodeA = zipcodeArrA[j];
          for (let k = j + 1; k < zipcodeArrA.length; k++) {
            const postalCodeB = zipcodeArrA[k];
            const bool = this.contrastPostalCode(postalCodeA, postalCodeB);
            if (!bool) {
              errObj.repeat.push((i + 1) + ':' + postalCodeA + ' and ' + (i + 1) + ':' + postalCodeB);
              return errObj;
            }
          }
        }
        // #
        for (let j = i + 1; j < arr.length; j++) {
          const itemB = arr[j];
          let zipcodeStrB = '';
          // 邮编长度
          if (itemB.postalCode) {
            zipcodeStrB = itemB.postalCode.trim();
          }
          // 替换 所有中文逗号为英文逗号
          zipcodeStrB = zipcodeStrB.replace(/，/ig, ',');
          const zipcodeArrB = zipcodeStrB.split(',').map(item => {
            return item.trim();
          });
          // 第一行的所有邮编和第二行所有邮编来一次
          for (let k = 0; k < zipcodeArrA.length; k++) {
            const postalCodeA = zipcodeArrA[k];
            for (let l = 0; l < zipcodeArrB.length; l++) {
              const postalCodeB = zipcodeArrB[l];
              const bool = this.contrastPostalCode(postalCodeA, postalCodeB);
              if (!bool) {
                errObj.repeat.push((i + 1) + ':' + postalCodeA + ' and ' + (j + 1) + ':' + postalCodeB + this.$t('basicData.intersect'));
                return errObj;
              }
            }
          }
        }
      }
      return errObj;
    },
    // 对比邮编
    contrastPostalCode(intervalA, intervalB) {
      if (intervalA === null || intervalA === '' || intervalA === undefined) {
        return true;
      }
      if (intervalB === null || intervalB === '' || intervalB === undefined) {
        return true;
      }
      const addZipcodeList = intervalA.split('~');
      const existZipCodeList = intervalB.split('~');
      // 如果两个都是 ~ 的邮编
      if (addZipcodeList.length === 2 && existZipCodeList.length === 2) {
        const min1 = parseInt(addZipcodeList[0]);
        const max1 = parseInt(addZipcodeList[1]);
        const min2 = parseInt(existZipCodeList[0]);
        const max2 = parseInt(existZipCodeList[1]);
        if (!((max1 < min2) || (max2 < min1))) {
          return false;
        }
      }
      // 前面的没有~  后面有~
      if (addZipcodeList.length === 1 && existZipCodeList.length === 2) {
        const min1 = parseInt(addZipcodeList[0]);
        const min2 = parseInt(existZipCodeList[0]);
        const max2 = parseInt(existZipCodeList[1]);
        if (!(((min1 < min2) && (max2 > min1)) || (max2 < min1))) {
          return false;
        }
      }
      // 都没有~
      if (addZipcodeList.length === 1 && existZipCodeList.length === 1) {
        const min1 = parseInt(addZipcodeList[0]);
        const min2 = parseInt(existZipCodeList[0]);
        if (min1 === min2) {
          return false;
        }
      }

      if (addZipcodeList.length === 2 && existZipCodeList.length === 1) {
        const min1 = parseInt(addZipcodeList[0]);
        const max1 = parseInt(addZipcodeList[1]);
        const min2 = parseInt(existZipCodeList[0]);
        if (!(((min2 < min1) && (max1 > min2)) || (max1 < min2))) {
          return false;
        }
      }
      return true;
    },
    // 处理提交的数据格式
    setSubmitFormDataType() {
      const tableData = this.formData.partitionAffiliateList;

      return tableData.map(item => {
        const { postalCode, partitionIdentifier, id, state, city } = item;
        const stateStr = state ? state.join(',') : '';
        const cityStr = city ? city.join(',') : '';
        const obj = {
          partitionIdentifier,
          postalCode, // 邮编
          id,
          state: stateStr,
          city: cityStr,
          partitionId: this.editData.id
        };
        return obj;
      });
    },

    // 新增
    asyncAffiliateAdd(obj) {
      apiAffiliateAdd(obj).then(res => {
        const { code } = res;
        if (code !== 200) {
          return;
        }
        this.$message.success(this.$i18n.t('basicData.TheOperationSucceeded')); // 操作成功
        this.handleUpdatePage(true);
      }).catch(err => {
        console.error(err);
      });
    },
    // 查看分区详情
    asyncGetAffiliateById(ids) {
      apiGetAffiliateById(ids).then(res => {
        const { code, data } = res;
        if (code !== 200) {
          return;
        }
        const {
          businessType,
          name,
          remark,
          partitionAffiliateList
        } = data;
        this.formData = {
          businessType,
          name,
          remark,
          partitionAffiliateList
        };
        this.formData.partitionAffiliateList.map((item, index) => {
          // 处理 city 字段
          if (typeof item.city === 'string' && item.city.trim() !== '') {
            try {
              item.city = item.city.split(',').map(Number);
            } catch (e) {
              console.warn('Invalid city format:', item.city);
              item.city = [];
            }
          } else {
            item.city = [];
          }
          item.allState = this.allState;
          item.key = this.generateUniqueKey(index);
          if (typeof item.state === 'string' && item.state.trim() !== '') {
            try {
              const stateList = item.state.split(',').map(Number);
              item.state = stateList;

              if (stateList.length > 0) {
                const param = {
                  pageNumber: 1,
                  pageSize: 99999,
                  params: {
                    level: 2,
                    parentIdList: stateList
                  }
                };

                apiAreaPage(param).then(res => {
                  if (res.code === 200) {
                    item.allCity = res.data.records;
                    this.cityKey = new Date().getTime();
                  }
                });
              }
            } catch (e) {
              item.state = [];
              item.allCity = this.allCity;
            }
          } else {
            item.state = [];
            item.allCity = this.allCity;
          }
        });
      });
    },
    // 编辑
    asyncAffiliateEdit(obj) {
      apiAffiliateEdit(obj).then(res => {
        const { code } = res;
        if (code !== 200) {
          return;
        }
        this.$message.success(this.$i18n.t('basicData.TheOperationSucceeded'));
        this.handleUpdatePage(true);
      }).catch(err => {
        console.error(err);
      });
    },
    // 保存
    submitForm() {
      this.errData = [];
      let flag = true;
      // 1.验证表单
      this.$refs.queryForm.validate((valid) => {
        if (!valid) {
          flag = false;
          return false;
        }
      });
      if (!flag) return;
      // 2.验证tableForm
      if (this.formData.partitionAffiliateList.length === 0) {
        return this.$message.warning(this.$t('basicData.PleaseAddPartitions')); // `请添加分区`,);
      }
      this.$refs.tableForm.validate((tabRules) => {
        console.log(tabRules, 'tabRules888888888888888888888888888888');
        if (!tabRules) {
          flag = false;
          return false;
        }
      });
      if (!flag) return;
      console.log(flag, 'flag8888888888');
      const loadingInstance = Loading.service(options);
      // 邮编校验
      const errCode = this.verifyZipCode(this.formData.partitionAffiliateList);
      console.log(errCode);
      if (errCode.errArr.length > 0) {
        // const tip = this.$i18n.t('basicData.Lines') + `${errCode.errArr.join(',')}` + this.$i18n.t('basicData.areMalformed'); // 第*和*邮编格式错误
        errCode.errArr.map(item => {
          this.errData.push(item);
        });
      }
      if (errCode.repeat.length > 0) {
        // const tip = this.$i18n.t('basicData.Lines') + `${errCode.repeat.join(',')}` + this.$i18n.t('basicData.intersect'); // 第*和*邮编存在交集
        errCode.repeat.map(item => {
          this.errData.push(item);
        });
      }
      const findByItems = (eq) => (arr) => arr.filter(
        (x, i) => arr.find((y, j) => i !== j && eq(x, y))
      );
      const duplicatedItems = findByItems((a, b) => a.partitionIdentifier.toString() === b.partitionIdentifier.toString());
      const duplicatedZipCode = findByItems((a, b) => a.postalCode === b.postalCode);
      // const duplicatedCity = findByItems((a, b) => a.city.toString() === b.city.toString());
      // const duplicatedState = findByItems((a, b) => a.state.toString() === b.state.toString());
      const haveIntersection = (arr1, arr2) => {
        return arr1.some(item => arr2.includes(item));
      };
      const arrDuplicated = duplicatedItems(this.formData.partitionAffiliateList);
      const arrZipCode = duplicatedZipCode(this.formData.partitionAffiliateList);
      const arrCityState = cloneDeep(this.formData.partitionAffiliateList);
      // const arrState = duplicatedState(this.formData.partitionAffiliateList);
      const nameArr = [];
      const zipCode = [];
      const city = [];
      const state = [];
      this.formData.partitionAffiliateList.map((item, ind) => {
        arrDuplicated.map(list => {
          if (list.partitionIdentifier === item.partitionIdentifier) {
            if (!nameArr.includes(ind + 1)) {
              nameArr.push(ind + 1);
            }
          }
        });
        arrZipCode.map((list, index) => {
          if (index !== ind) {
            if (
              (list.postalCode !== null && list.postalCode !== '' && list.postalCode !== undefined) &&
              (item.postalCode !== null && item.postalCode !== '' && item.postalCode !== undefined)
            ) {
              if (list.postalCode === item.postalCode) {
                if (!zipCode.includes(ind + 1)) {
                  zipCode.push(ind + 1);
                }
              }
            }
          }
        });
        arrCityState.map((list, index) => {
          if (index !== ind) {
            if (
              (
                (list.postalCode === null || list.postalCode === undefined || list.postalCode === '') &&
                (list.postalCode === null || list.postalCode === undefined || list.postalCode === '')
              )
            ) {
              if (
                (list.city !== null && list.city !== undefined && list.city.length !== 0) &&
                (item.city !== null && item.city !== undefined && item.city.length !== 0)
              ) {
                if (haveIntersection(list.city, item.city)) {
                  if (!city.includes(ind + 1)) {
                    city.push(ind + 1);
                  }
                }
              }
            }
            if (
              (
                (list.postalCode === null || list.postalCode === undefined || list.postalCode === '') &&
                (list.city === null || list.city === undefined || list.city.length === 0)
              ) &&
              (
                (item.postalCode === null || item.postalCode === '' || item.postalCode === undefined) &&
                (item.city === null || item.city === undefined || item.city.length === 0)
              )
            ) {
              if (
                (list.state !== null && list.state !== undefined && list.state.length !== 0) &&
                (item.state !== null && item.state !== undefined && item.state.length !== 0)
              ) {
                if (haveIntersection(list.state, item.state)) {
                  if (!state.includes(ind + 1)) {
                    state.push(ind + 1);
                  }
                }
              }
            }
          }
        });
      });
      if (nameArr.length > 1) {
        const tip = this.$i18n.t('basicData.Lines') + `${nameArr.join(',')}` + this.$i18n.t('basicData.repeat'); // 第*和*行重复
        this.errData.push(tip);
      }
      if (zipCode.length > 1) {
        const tip = this.$i18n.t('basicData.Lines') + `${zipCode.join(',')}` + this.$i18n.t('basicData.areDuplicated'); // 第*和*行重复
        this.errData.push(tip);
      }
      if (city.length > 1) {
        const tip = this.$i18n.t('basicData.Lines') + `${city.join(',')}` + this.$i18n.t('basicData.theCityIsDuplicated'); // 第*和*行重复
        this.errData.push(tip);
      }
      if (state.length > 1) {
        const tip = this.$i18n.t('basicData.Lines') + `${state.join(',')}` + this.$i18n.t('basicData.StateDuplication'); // 第*和*行重复
        this.errData.push(tip);
      }
      console.log('重复的state', state, this.errData);
      if (this.errData.length > 0) {
        this.dialogVisible = true;
        loadingInstance.close();
        return;
      }
      const arr = this.setSubmitFormDataType();
      const { name, remark, businessType } = this.formData;
      const obj = {
        id: '',
        name,
        businessType,
        remark,
        attribute: 2,
        partitionAffiliateList: arr
      };
      loadingInstance.close();
      if (this.typeIndex === 1) {
        // 1.新增
        this.asyncAffiliateAdd(obj);
        return;
      }

      if (this.typeIndex === 2) {
        // 2.编辑
        obj.id = this.editData.id;
        this.asyncAffiliateEdit(obj);
      }
    },
    generateUniqueKey(index) {
      return `item-${Date.now()}-${index}-${Math.random().toString(36).substr(2, 9)}`;
    },
    // 搜索处理
    handleSearch() {
      const searchTerm = this.searchCode.trim();
      const tableData = this.formData.partitionAffiliateList;

      if (!searchTerm) {
        this.searchResults = [];
        this.currentHighlightIndex = -1;
        return;
      }

      // const results = tableData
      //   .map((row, index) => ({ row, index }))
      //   .filter(item => item.row.postalCode && item.row.postalCode.includes(searchTerm));

      const results = tableData
        .map((row, index) => ({ row, index }))
        .filter(item => {
          const { postalCode } = item.row;
          const postalCodeList = this.parseDataRanges(postalCode);
          console.log('postalCodeList', postalCodeList);
          const {
            matched,
            matchedRange
          } = this.postalCodeFormat(searchTerm, postalCodeList);
          console.log('matched', matched, matchedRange);
          return matched;
        });

      this.searchResults = results;
      this.currentHighlightIndex = results.length ? 0 : -1;

      if (results.length > 0) {
        this.$nextTick(() => this.scrollToHighlightedRow());
      }
    },

    // 下一个
    highlightNext() {
      if (!this.hasSearchResults) return;
      this.currentHighlightIndex = (this.currentHighlightIndex + 1) % this.searchResults.length;
      this.$nextTick(() => this.scrollToHighlightedRow());
    },

    // 上一个
    highlightPrev() {
      if (!this.hasSearchResults) return;
      this.currentHighlightIndex =
        this.currentHighlightIndex <= 0
          ? this.searchResults.length - 1
          : this.currentHighlightIndex - 1;
      this.$nextTick(() => this.scrollToHighlightedRow());
    },

    // 滚动到当前高亮行
    scrollToHighlightedRow() {
      // 获取表格的虚拟滚动实例
      const virtualScroll = this.$refs.virtualScroll.$el;

      if (this.currentHighlightIndex < 0) return;

      const currentMatch = this.searchResults[this.currentHighlightIndex];
      if (!currentMatch) return;

      const rowIndex = currentMatch.index;

      const rowHeight = 76; // 每行的预计高度，根据实际情况调整
      const viewportHeight = virtualScroll.clientHeight; // 可视区域高度
      // const totalRows = this.formData.partitionAffiliateList.length; // 表格总行数
      const maxRowsInViewport = Math.floor(viewportHeight / rowHeight); // 可视区域最多能显示的行数
      const startIndex = Math.max(0, rowIndex - Math.floor(maxRowsInViewport / 2)); // 计算开始滚动的行索引
      const scrollTop = rowHeight * startIndex; // 计算需要滚动的位置
      console.log('scrollTop', scrollTop, startIndex);
      this.setScrollTop(scrollTop);

      // 强制表格重新渲染以应用高亮样式
      this.$nextTick(() => {
        if (this.$refs.virtualScroll && this.$refs.virtualScroll.doLayout) {
          this.$refs.virtualScroll.doLayout();
        }
      });
    },
    // 清空搜索结果
    clearHighlight() {
      this.searchCode = '';
      this.searchResults = [];
      this.currentHighlightIndex = -1;
      this.$nextTick(() => {
        this.setScrollTop();
      });
    },
    // 设置滚动距离
    setScrollTop(top = 0) {
      const tableRef = this.$refs.tableRef.$el.querySelector('.el-table__body-wrapper'); // 表格元素
      tableRef.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    },

    // 获取行类名
    getRowClassName({ row, rowIndex }) {
      return this.isRowHighlighted(row, rowIndex) ? 'highlighted-row' : '';
    },

    // 检查行是否高亮
    isRowHighlighted(row, rowIndex) {
      if (this.currentHighlightIndex < 0) return false;

      const currentResult = this.searchResults[this.currentHighlightIndex];
      return currentResult && currentResult.row.key === row.key;
    },
    // 邮编匹配规则
    postalCodeFormat(value, parsedRanges) {
      const number = parseFloat(value);

      let matched = false;
      let matchedRange = null;

      for (const range of parsedRanges) {
        if (range.type === 'single') {
          if (range.value.includes(number)) {
            matched = true;
            matchedRange = range;
            break;
          }
        } else if (range.type === 'range') {
          if (number >= range.start && number <= range.end) {
            matched = true;
            matchedRange = range;
            break;
          }
        }
      }
      return {
        matched,
        matchedRange
      };
    },
    // 邮编解析
    parseDataRanges(code) {
      const ranges = [];
      const parts = code.split(',');

      for (const part of parts) {
        const trimmedPart = part.trim();

        if (trimmedPart.includes('~')) {
          // 处理区间
          const [start, end] = trimmedPart.split('~').map(num => parseFloat(num.trim()));
          if (!isNaN(start) && !isNaN(end)) {
            ranges.push({ type: 'range', start, end });
          }
        } else {
          // 处理单个数字
          const num = parseFloat(trimmedPart);
          if (!isNaN(num)) {
            ranges.push({ type: 'single', value: num.toString() });
          }
        }
      }

      return ranges;
    }

    // 高亮code文本
    // highlightCode(code) {
    //   const searchTerm = this.searchCode.trim();
    //   if (!searchTerm) return code;
    //
    //   const regex = new RegExp(`(${this.escapeRegExp(searchTerm)})`, 'gi');
    //   return code.replace(regex, '<mark class="code-highlight">$1</mark>');
    // },
    //
    // // 转义正则表达式特殊字符
    // escapeRegExp(string) {
    //   return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    // }
  }
};
</script>

<style scoped lang="scss">
::v-deep .highlighted-row,
::v-deep .highlighted-row:hover > td {
  background-color: #e6f7ff !important;
}

::v-deep .highlighted-row {
  position: relative;
}

::v-deep .highlighted-row::after {
  position: absolute;
  content: '';
  width: 5px;
  height: 100%;
  background-color: #1890ff;
  left: 0;
}

::v-deep .code-highlight {
  background-color: #ffeb3b;
  padding: 2px 4px;
  border-radius: 2px;
  font-weight: bold;
}

::v-deep .el-table__row {
  transition: all 0.3s ease;
}

.boxInfo {
  height: 100%;

  ::v-deep .el-tabs__content {
    //height: calc(100% - 40px);
    padding: 0;
    //overflow-y: auto !important;

    .el-tab-pane {
      height: 100%;

      .addFormBox {
        height: calc(100vh - 96px);
        padding: 15px;
        overflow-y: auto;
      }
    }
  }

  .addFooter {
    border-top: 1px solid #ccc;
    padding: 10px;
    text-align: right;
  }
}
</style>

